import { useState } from 'react'
import { useAuth } from '../contexts/Auth'
import Logo from '../ui_icons/logo.svg'
import LogoutIcon from '../ui_icons/logout.svg'
import Help from './Help'

export default function Header({ hidden }) {
  const { user, handleLogout } = useAuth()
  const [modal, setModal] = useState()

  return (
    <header className={hidden ? 'hidden' : null}>
      <img id="logo" src={Logo} alt="TED Logo" />
      <h1>Stage Notifier</h1>
      <div id="header-buttons">
        <Help modal={modal} setModal={setModal} />
        {user ? (
          <button onClick={handleLogout}>
            <img src={LogoutIcon} alt="Log out" />
          </button>
        ) : null}
      </div>
    </header>
  )
}
